import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-popup-wizard-header',
    templateUrl: './popup-wizard-header.component.html',
    styleUrls: ['./popup-wizard-header.component.scss'],
    standalone: false
})
export class PopupWizardHeaderComponent {

    @Input()
    public header: string | undefined;

    @Input()
    public description: string | undefined;
}
